import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65e14258"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "luosike-history-container" }
const _hoisted_2 = { class: "integral-change" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "date-wrap" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "footer" }, "-- 没有更多 --", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.luosikeList, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "luosike-item",
        key: item.optTime
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "label",
            textContent: _toDisplayString(item.taskName)
          }, null, 8, _hoisted_3),
          _createElementVNode("div", {
            class: _normalizeClass([
            'value',
            item.awardNum > 0 && 'increase',
            item.awardNum < 0 && 'decrease',
          ]),
            textContent: _toDisplayString(item.awardNum)
          }, null, 10, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "date",
            textContent: _toDisplayString(item.optTime)
          }, null, 8, _hoisted_6),
          _createElementVNode("div", {
            class: "label",
            textContent: _toDisplayString(item.awardName)
          }, null, 8, _hoisted_7)
        ])
      ]))
    }), 128)),
    _hoisted_8
  ]))
}